import React from 'react';
import { bool, shape, string } from 'prop-types';

const FieldTypeColor = ({
  className = '',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.75 4.5C10.2675 4.5 8.25 6.5175 8.25 9C8.25 11.4825 10.2675 13.5 12.75 13.5C15.2325 13.5 17.25 11.4825 17.25 9C17.25 6.5175 15.2325 4.5 12.75 4.5ZM3.75 6C2.0925 6 0.75 7.3425 0.75 9C0.75 10.6575 2.0925 12 3.75 12C5.4075 12 6.75 10.6575 6.75 9C6.75 7.3425 5.4075 6 3.75 6ZM9.75 9C9.75 10.6575 11.0925 12 12.75 12C14.4075 12 15.75 10.6575 15.75 9C15.75 7.3425 14.4075 6 12.75 6C11.0925 6 9.75 7.3425 9.75 9Z" fill="currentColor" />
  </svg>
);

FieldTypeColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FieldTypeColor;
